<template>
  <div class="Aviso">
    <headNav :activeNav="'loan'"></headNav>
    <img
      src="../assets/image/3_banner.png"
      style="height: auto"
      class="banner"
      alt=""
    />
    <div class="bigContent">
      <p class="title">Términos y condiciones</p>
      <div class="content">
        <p>
          La utilización del portal https://www.rapidayuda.com/home (en lo
          sucesivo la “Página Web”) y de la aplicación para dispositivos móviles
          Android denominada “Rapidayuda” (en lo sucesivo la “App”), expresa la
          adhesión plena y sin reservas por parte del usuario a los presentes
          Términos y Condiciones y al Aviso de Privacidad de Mobene digital tech
          services SA de cv (en lo sucesivo “MOBENE”), documentos que se
          encuentran a disposición de los usuarios en todo momento a través de
          dichos medios y físicamente en el domicilio de MOBENE.
        </p>
        <p>
          Para efectos del presente documento, se entenderá por usuario a toda
          persona que acceda, navegue, descargue y/o se registre en la Página
          Web y/o la Aplicación para la obtención de los servicios financieros
          de MOBENE.
        </p>
        <p>
          Los productos y servicios financieros de MOBENE están dirigidos única
          y exclusivamente a personas físicas mexicanas con capacidad legal para
          contratar por lo que están expresamente excluidos los menores de edad,
          personas declaradas en estado de interdicción, aquellos limitados por
          otro contrato, convenio o relación comercial, enunciativa más no
          limitativamente, así como los usuarios que hayan sido vetados
          definitiva o temporalmente por MOBENE en relación a su comportamiento
          crediticio.
        </p>
        <p>
          En consecuencia, al acceder a la Página Web y/o al utilizar la
          Aplicación de MOBENE, el usuario manifiesta y garantiza que es mayor
          de edad de acuerdo a la legislación de la República Mexicana.
        </p>
        <p>
          Los Servicios ofrecidos por MOBENE a través de la Página Web y/o la
          Aplicación serán válidos única y exclusivamente en el territorio de la
          República Mexicana, por lo que en caso de que la Página Web y/o la
          Aplicación pudieran ser accedidos desde diversos países alrededor del
          mundo, esto en ningún caso implicará que MOBENE autorice o habilite
          sus servicios y/o contenidos en tales países o en diversas
          jurisdicciones.
        </p>
        <p>
          <span>1.</span> Aceptación. El usuario entiende y acepta que al
          ingresar y navegar en la Página Web y/o al registrarse y/o utilizar la
          App, manifiesta de forma indubitable su voluntad plena y sin reservas
          de quedar sujeto a los presentes Términos y Condiciones, los cuales
          tienen carácter obligatorio y vinculante, por lo que, en caso de no
          aceptar o no estar de acuerdo con estos Términos y Condiciones, y/o
          con el Aviso de Privacidad de MOBENE, deberá abstenerse de continuar
          navegando en la Página Web, así como de utilizar la App. En este
          sentido es responsabilidad del usuario leer y entender íntegramente
          las condiciones establecidas a continuación, antes de realizar
          cualquier gestión dentro de la Página Web y/o de registrarse y
          solicitar cualquier servicio en la App.
        </p>
        <p>
          <span>2.</span> Uso debido y restricciones. Toda aquella persona que
          acceda, mediante el uso de un equipo de cómputo, tableta, celular y/o
          cualquier otro dispositivo con acceso a Internet a la Aplicación y/o a
          la Página Web, está de acuerdo en no utilizar dichos dispositivos,
          programas de cómputo, software, o cualquier otro medio para interferir
          o afectar, tanto las funcionalidades, actividades y/u operaciones de
          la Aplicación y/o del Página Web, así como las bases de datos y/o
          información que se contenga en los mismos.
        </p>
        <p>
          El usuario se compromete a utilizar y acceder a la Aplicación y/o a la
          Página Web y a hacer uso de los servicios conforme a lo establecido en
          las leyes, la moral, las buenas costumbres y el orden público, por lo
          que se obliga a abstenerse de utilizar la App, la Página Web y los
          servicios de MOBENE con fines y/o efectos ilícitos, lesivos de
          derechos e intereses de terceros, o que de cualquier forma puedan
          dañar, inutilizar, sobrecargar o deteriorar la Página Web y/o la
          Aplicación o impedir el uso por parte de otros usuarios.
        </p>
        <p>
          El usuario acepta que es responsable de contar con software y hardware
          compatible, los dispositivos necesarios, conexión a la red de
          Internet, y cualquier otro requerimiento técnico necesario para la
          correcta ejecución de la Aplicación y/o de la Página Web.
        </p>
        <p>
          El usuario entiende que si accede o utiliza la Aplicación y/o navega
          en la Página Web desde un dispositivo móvil, podrán aplicarse las
          tarifas y tasas de datos y mensajes de su proveedor de red móvil.
        </p>
        <p>
          MOBENE no garantiza que la Aplicación y/o la Página Web funcionen en
          todos los dispositivos. El Usuario también es responsable de permitir
          y ejecutar las actualizaciones de la Aplicación que resulten
          necesarias para su correcta y puntual utilización.
        </p>
        <p>
          MOBENE podrá proporcionar enlaces directos a otras Páginas Webs y/o a
          otros recursos de terceros, sobre los cuales MOBENE no tiene control,
          ni asume responsabilidad sobre la licitud de su contenido,
          disponibilidad, accesibilidad o veracidad de la información en ellos.
        </p>
        <p>
          MOBENE no será responsable por pérdidas o daños causados, o
          supuestamente causados por, o en conexión con el uso y la seguridad
          sobre el contenido, productos y/o servicios disponibles a través de
          cualquiera de dichos sitios o recursos de terceros.
        </p>
        <p>
          <span>3.</span>
          Registro/Creación de cuenta. Todo usuario que pretenda solicitar los
          productos y servicios financieros de MOBENE deberá registrarse
          previamente a través de la Aplicación y/o en la Página Web, mediante
          la creación de un usuario y contraseña a través del llenado de la
          solicitud correspondiente en todos sus campos; pudiendo optar, en caso
          de estar habilitada dicha opción, para agilizar la creación de su
          cuenta, por ingresar su usuario y contraseña de sus redes sociales, de
          donde MOBENE tomará únicamente los datos necesarios para realizar su
          registro.
        </p>
        <p>
          Para el registro el usuario deberá proporcionar los datos siguientes:
          cuenta de e-mail personal; número de teléfono celular, correo
          electrónico, entre otros datos.
        </p>
        <p>
          Asimismo, el usuario para completar su registro y creación de la
          cuenta deberá otorgar su consentimiento expreso a MOBENE para:
        </p>
        <p>
          3.1 Enviarle mensajes de texto para la autenticación de la identidad
          de aquél, en el entendido de que el envío de los mensajes de texto
          será a demanda del usuario.
        </p>
        <p>
          3.2 El tratamiento de sus datos personales y datos personales
          sensibles bajo los términos de su Aviso de Privacidad vigente, mismo
          que se pondrá a su disposición durante el registro y que en todo
          momento podrá ser consultado en la página de internet:
        </p>
        <p>
          En adición a lo anterior, el usuario podrá autorizar a MOBENE para
          hacerle llegar publicidad relacionada con los Servicios que ofrece y/o
          para que sus datos personales sean utilizados con fines
          mercadotécnicos y/o publicitarios.
        </p>
        <p>
          Una vez ingresados los datos requeridos, el usuario recibirá un número
          de confirmación al número de teléfono celular que indicó para la
          autenticación de su identidad, el cual deberá ingresar en la
          Aplicación para concluir con el registro. El envío de dichos códigos
          se entiende realizado por solicitud del usuario.
        </p>
        <p>
          La cuenta es personal, única e intransferible, y está prohibido que un
          mismo usuario inscriba o posea más de una cuenta. En caso de que
          MOBENE detecte distintas cuentas que contengan datos coincidentes o
          relacionados, podrá cancelar, suspender o inhabilitarlas, sin
          responsabilidad alguna.
        </p>

        <p>
          <span>4.</span>Acceso a la cuenta. Concluido satisfactoriamente el
          registro, el usuario podrá acceder a su cuenta personal mediante el
          ingreso del usuario y contraseña asignados.
        </p>
        <p>
          El usuario se obliga a mantener la confidencialidad de su Contraseña,
          pues entiende que será responsable por todas las operaciones
          efectuadas en y desde su cuenta, toda vez que el acceso a la misma
          está restringido al ingreso y uso de su contraseña, la cual es de su
          conocimiento exclusivo.
        </p>
        <p>
          <span>5.</span>Solicitud de crédito. Una vez completado el registro y
          habiendo accedido el usuario a su cuenta, podrá solicitar los
          servicios financieros de MOBENE, para lo cual deberá llenar la
          Solicitud de Crédito en todos sus campos.
        </p>
        <p>
          El Usuario garantiza y se obliga a responder, en cualquier caso, de la
          veracidad, exactitud, vigencia y autenticidad de los datos ingresados
          en su Solicitud de Crédito, asumiendo la obligación de actualizarlos
          conforme resulte necesario para la debida prestación de los servicios.
        </p>
        <p>
          En adición a los datos requeridos, el usuario deberá ingresar una
          fotografía de su Credencial para votar vigente por ambos lados en el
          que sea plenamente visible el código de barras, así como una
          fotografía del mismo usuario sosteniendo dicha identificación oficial
          (en lo sucesivo “Foto Selfie”) para prevenir el robo de identidad.
        </p>
        <p>
          5.1. Autorización para validación de datos. El Usuario reconoce y
          acepta que MOBENE podrá utilizar diversos medios para verificar su
          identidad, así como la precisión de la información y datos personales
          indicados en la Solicitud de Crédito.
        </p>
        <p>
          En virtud de lo anterior, en caso de estar de acuerdo deberá
          manifestar su consentimiento expreso por medios electrónicos para que
          MOBENE corrobore los datos proporcionados, con los registros que obran
          en poder del Instituto Nacional Electoral, el Servicio de
          Administración Tributaria y el Registro Nacional de Población, a
          través del Servicio de Verificación de datos de la Credencial para
          Votar.
        </p>
        <p>
          MOBENE se reserva el derecho de solicitar documentación adicional con
          el fin de corroborar los datos ingresados en la solicitud, así como de
          suspender temporal o definitivamente las cuentas y/o negar las
          solicitudes de aquellos usuarios cuyos datos no hayan podido ser
          confirmados, sean detectados como alterados o falsificados.
        </p>
        <p>
          Asimismo, el Usuario autoriza a MOBENE para que una vez que cuente con
          toda la información y datos personales requeridos, realice la consulta
          de su historial crediticio en la sociedades de información crediticia
          con las que tenga celebrado contrato, y la procese bajo el modelo de
          calificación de crédito de MOBENE, con lo cual se determinará si se
          aprueba o niegan los servicios al Usuario.
        </p>
        <p>
          5.2 Aprobación o negación de la solicitud de crédito. La Solicitud de
          Crédito del usuario, no generará obligación alguna a cargo de MOBENE,
          toda vez que la aprobación del crédito, en todo momento estará sujeta
          a la verificación, por parte de MOBENE, de la información y
          documentación proporcionada por el usuario en la misma.
        </p>
        <p>
          En tal virtud y hasta en tanto no se haya notificado por parte de
          MOBENE la autorización del Crédito no se entenderá perfeccionado
          ningún otorgamiento de crédito, por dicho motivo el usuario entiende
          que la aceptación de los presentes Términos y Condiciones no
          representa ofrecimiento formal alguno por parte de MOBENE y no implica
          que el Crédito haya sido o que será autorizado.
        </p>
        <p>
          <span>6.</span> Uso no autorizado. El usuario se compromete a
          notificar a MOBENE en forma inmediata, cualquier uso no autorizado de
          su cuenta, así como el ingreso por terceros no autorizados a la misma,
          destacando que está prohibida la venta, cesión o transferencia de la
          cuenta. MOBENE no se hará responsable, por errores generales o
          tipográficos en los cuales incurra el usuario o por negligencia al
          usar los servicios de la Aplicación y/o la Página Web, de igual forma
          MOBENE se exime de responsabilidad ante negligencia al dejar cualquier
          dispositivo electrónico, mediante el cual tenga acceso a la App, la
          Página Web y los servicios, sin atención alguna, reservándose el
          derecho de rechazar cualquier solicitud de registro o de cancelar una
          solicitud previamente aceptada, sin que esté obligado a exponer las
          razones de su decisión y sin que ello genere algún derecho a
          indemnización al usuario.
        </p>
        <p>
          <span>7.</span>Cancelación de cuenta. El Usuario podrá cancelar en
          cualquier momento su cuenta, siempre y cuando no exista alguna
          obligación de pago pendiente a favor de MOBENE.
        </p>
        <p>
          <span>8.</span>Condiciones Generales de los servicios. MOBENE ofrece a
          través de la Aplicación y su Página Web productos y servicios de
          otorgamiento de crédito dentro de la República Mexicana, cuyos
          términos y condiciones particulares se detallan en un Contrato de
          Crédito, el cual se encuentra debidamente registrado en el Registro de
          Contratos de Adhesión (RECA) de la Comisión Nacional para la
          Protección y Defensa de los Usuarios de Servicios Financieros
          (CONDUSEF) y que en todo momento se encuentra disponible para consulta
          del usuario a través de la página de la CONDUSEF en adición de la
          Aplicación y la Página Web de MOBENE.
        </p>
        <p>
          Sin perjuicio de las condiciones particulares aplicables a cada
          usuario, derivadas de los resultados del análisis del riesgo que se
          realice al usuario, mismas que se detallarán en el Contrato que
          lleguen a celebrar el usuario y MOBENE por medios electrónicos;
          MOBENE, hace de su conocimiento las condiciones generales aplicables a
          los servicios:
        </p>
        <p>
          (a) La solicitud, contratación y prestación de servicios financieros
          de MOBENE se realiza exclusivamente por medios electrónicos de
          conformidad con la legislación aplicable y vigente; (b) MOBENE pondrá
          a disposición del usuario mecanismos que le permitan expresar su
          consentimiento expreso a través de medios electrónicos, en los casos
          en que así se requiera en términos de las leyes aplicables, así como
          para efecto de celebrar el Contrato; (c) MOBENE podrá establecer
          diversos requisitos de contratación/elegibilidad para cada producto,
          mismos que pueden consultarse en la página de internet:
          https://www.rapidayuda.com/home ; (d) A través de la celebración de un
          Contrato de Apertura de Crédito en Cuenta Corriente con Expedición de
          Tarjeta de Crédito, se podrá conceder al usuario una línea de crédito
          cuyo límite dependerá en cada caso de la evaluación de crédito
          realizada y del tipo de producto que corresponda; (e) Los intereses
          ordinarios se calcularán de acuerdo a los resultados del análisis del
          riesgo que se realice al usuario; (f) En caso de incumplimiento de
          pago puntual, ya sea este parcial o total, el usuario deberá cubrir a
          MOBENE una comisión de pago tardío; (g) El usuario podrá realizar el
          pago parcial o total de las disposiciones realizadas a través de
          transferencias electrónicas y/o directamente en cualquier sucursal de
          las instituciones bancarias y/o tiendas de conveniencia con las que
          MOBENE tenga suscrito un convenio, mismas que pueden consultarse en la
          página de internet https://www.rapidayuda.com/home ; (h) Solo otorgará
          una línea de crédito por usuario; (i) El usuario autoriza expresamente
          a MOBENE para que, en caso de incurrir en incumplimiento de pago,
          MOBENE pueda utilizar el número telefónico, correo electrónico, perfil
          de Facebook y/o redes sociales que proporcionó para requerirle el
          pago, ya sea a través de llamada, SMS, WhatsApp y/o mensaje privado;
          (j) MOBENE reportará de forma mensual su comportamiento de pago a
          sociedades de información crediticia con las que tenga celebrado
          contrato.
        </p>
        <p>
          <span>9.</span>Modificaciones de los Términos y Condiciones. MOBENE
          podrá modificar los Términos y Condiciones en cualquier momento,
          haciendo públicos en la Aplicación o en la Página Web los términos
          modificados. En caso de desacuerdo del usuario respecto de los cambios
          realizados, deberá comunicarlo por correo electrónico a la siguiente
          cuenta https://www.rapidayuda.com/home dentro de los 5 (cinco) días
          siguientes a la publicación de las modificaciones; en ese caso será
          cancelada la cuenta del usuario siempre que no subsistan montos
          pendientes a favor de MOBENE. Vencido este plazo, sin oposición del
          usuario se considerará que este acepta los nuevos Términos y
          Condiciones.
        </p>
        <p>
          <span>10.</span>Inhabilitación de la cuenta. Sin perjuicio de otras
          medidas, MOBENE podrá suspender, sin requisito o formalidad alguna, en
          forma temporal o inhabilitar definitivamente la cuenta del usuario y/o
          suspender la prestación de sus servicios si el usuario: (a)
          Trasgrediera alguna ley, o cualquiera de las estipulaciones de los
          presentes Términos y Condiciones. (b) Incumpliera sus compromisos como
          usuario. (c) Incurriera a criterio de MOBENE en conductas o actos
          fraudulentos. (d) No pudiera verificarse la identidad del usuario o
          cualquier información proporcionada por el mismo fuere errónea o
          falsa.
        </p>
        <p>
          <span>11.</span>Responsabilidad por fallas en el sistema y/o en el
          contenido de la Aplicación o de la Página Web. MOBENE mantendrá la
          Aplicación y la Página Web, así como sus contenidos, de forma
          razonablemente correcta y actualizada, teniendo los controles de
          seguridad que a su criterio considere necesarios, buscando siempre la
          seguridad del usuario, sin embargo, no podrá garantizarle a este
          último que los sistemas y contenidos de éstas carezcan de errores,
          defectos, malware y/o virus, por lo que MOBENE no se responsabiliza
          por cualquier daño o perjuicio sufrido por el usuario como
          consecuencia y/o en relación con dichas fallas o errores.
        </p>
        <p>
          Asimismo, el usuario tendrá prohibido descargar elementos y/o
          contenidos de la Aplicación y/o la Página Web, salvo que esté
          expresamente autorizado por MOBENE; no obstante lo anterior, cualquier
          elemento que sea descargado por el usuario a través de la Aplicación
          y/o la Página Web, será bajo su propia discreción y riesgo, por lo que
          MOBENE tampoco asume responsabilidad alguna por cualquier virus que
          pudiera afectar o inhabilitar el equipo del usuario a raíz de
          cualquier descarga, transferencia de datos, archivos, imágenes,
          textos, o audio contenidos en los mismos, así como cualquier otra
          información enviada con el uso de medios electrónicos.
        </p>
        <p>
          El sistema puede eventualmente no estar disponible debido a
          dificultades técnicas o fallas de Internet, o por cualquier otra
          circunstancia ajena a MOBENE; por lo que MOBENE no garantiza el acceso
          y uso continuado o ininterrumpido de la Página Web, en tales casos
          únicamente procurará restablecerlo con la mayor celeridad posible, sin
          que por ello pueda imputársele algún tipo de responsabilidad.
        </p>
        <p>
          <span>12.</span>Propiedad Intelectual. El usuario no adquirirá bajo
          ninguna circunstancia licencia o derecho alguno sobre la propiedad
          intelectual de MOBENE por el mero uso de su App, la Página Web o de
          sus servicios; por lo tanto, su uso no podrá ser considerado como una
          autorización tácita o expresa para utilizar los sistemas y contenidos
          con algún fin diverso a los contemplados por el presente documento.
        </p>
        <p>
          El usuario reconoce y acepta que la App, la Página Web y cualquier
          software que sea necesario para permitirle acceder y usar su cuenta
          para solicitar y recibir los servicios de MOBENE, contienen
          información confidencial de MOBENE y/o de terceros, que se encuentra
          protegida por las leyes de propiedad intelectual y otras leyes
          aplicables, asimismo, el usuario reconoce que el contenido que consta
          en la Aplicación y la Página Web de MOBENE, son de la titularidad y
          propiedad exclusiva de MOBENE y por consecuencia sus derechos de uso y
          explotación que incluyen mas no se limitan a su publicación,
          reproducción, divulgación, transformación y distribución le
          corresponden únicamente a MOBENE y están protegidas por las normas
          nacionales e internacionales de derecho de autor, marcas, patentes,
          modelos y diseños industriales.
        </p>
        <p>
          Rapidayuda, se encuentra protegida en términos de la Ley de la
          Propiedad Industrial vigente. En consecuencia, la utilización,
          descarga, difusión, exhibición, explotación, comercialización y/o
          cualquier otro uso, sea parcial o total, de forma idéntica o que
          confunda en menor o mayor grado; sea por cualquier medio, incluyendo
          mas no limitándose al impreso, magnético, óptico, electrónico o
          informático, está expresamente prohibido sin previa autorización por
          escrito de MOBENE, S.A. DE C.V.
        </p>
        <p>
          Cualquier contravención a lo anteriormente expuesto o a la legislación
          aplicable en materia de propiedad intelectual, industrial, derechos de
          autor será considerada y perseguida como un delito. En consecuencia,
          el usuario entiende que le queda prohibido dar uso indebido, así como
          reproducir total o parcialmente dichos sistemas y contenidos.
        </p>
        <p>
          <span>13.</span>Incumplimiento e Indemnización. En caso de
          incumplimiento del usuario a cualquiera de las obligaciones derivadas
          de los presentes Términos y Condiciones, o en caso de violación a
          cualquier ley y/o derechos de terceros, MOBENE podrá dar por vencidas
          anticipadamente las obligaciones de pago del usuario de haberse
          concretado la relación contractual y proceder a la cancelación de la
          cuenta del usuario.
        </p>
        <p>
          En dichos casos, el usuario se obliga a cubrir el monto que en su caso
          adeude en virtud del Contrato y/o a indemnizar a MOBENE por los daños
          y perjuicios que le cause, debiendo cubrir además los gastos en que
          MOBENE pudiera incurrir, incluyendo honorarios razonables de abogados,
          comprometiéndose el usuario a sacar en paz y a salvo a MOBENE, sus
          empresas subsidiarias y/o controladoras, directivos, administradores,
          representantes y empleados, de cualquier reclamo o demanda de otros
          usuarios o terceros por sus actividades en la Aplicación o en la
          Página Web, y/o por su incumplimiento.
        </p>
        <p>
          13.1 Advertencias al usuario. Incumplir con las obligaciones puede
          generar comisiones. Contratar créditos por arriba de tu capacidad de
          pago puede afectar tu historial crediticio.
        </p>
        <p>
          <span>14.</span>Política de Privacidad. MOBENE para proveer los
          servicios, recaba información de carácter personal, inclusive datos
          personales sensibles de los usuarios, por lo cual los términos del
          tratamiento de dichos datos personales de los usuarios se encuentran
          especificados en su Aviso de Privacidad visible en la Aplicación y el
          Página Web, mismos que se tienen por aquí reproducidos y que en
          consecuencia forman parte integral de los presentes Términos y
          Condiciones.
        </p>
        <p>
          El Usuario entiende y acepta que por el sólo uso de la Aplicación y/o
          la Página Web, acepta haber leído, entendido y aceptado expresamente
          el Aviso de Privacidad y su contenido.
        </p>
        <p>
          <span>15.</span>Contacto. MOBENE estará a disposición del usuario en
          su domicilio localizado en la Calle Lázaro Cárdenas 196 A601 Guerrero
          06300 Cuauhtémoc, Ciudad de México correo electrónico
          Rapidayuda.prestamo@gmail.com, en un horario de 9:00 a 18:00 horas de
          lunes a viernes.
        </p>
        <p>
          <span>16.</span>Notificaciones, jurisdicción y ley aplicable. Todos
          los avisos y notificaciones que las partes deban o deseen hacerse en
          relación con estos Términos y Condiciones, deberán realizarse por
          correo electrónico, en el caso de aquellas dirigidos al usuario a la
          cuenta que se haya proporcionado al momento de su registro, y para
          aquellos dirigidos a MOBENE a la cuenta de contacto señalada en este
          instrumento.
        </p>
        <p>
          El Usuario señala como su domicilio para todos los efectos legales que
          tuvieran lugar el expresado en el formulario de datos para su
          registro.
        </p>
        <p>
          Para la interpretación, cumplimiento y ejecución del presente
          instrumento, las partes expresamente a las Leyes Federales vigentes en
          la República Mexicana y se someten a la jurisdicción de los Tribunales
          Federales Competentes con sede en la Ciudad de México, renunciando en
          consecuencia a cualquier otro fuero que, en razón de su domicilio
          presente o futuro o por cualquier otra razón pudiera corresponderles.
        </p>
        <p>
          Habiendo leído y entendido cada uno de los Términos y Condiciones, el
          usuario manifiesta su total aceptación y sujeción a cualquier
          obligación de ellos derivada, al hacer uso de la Página Web y/o la
          Aplicación.
        </p>
      </div>
    </div>

    <footPage></footPage>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import footPage from "@/components/oldFoot.vue";
import "../components/scss/Aviso.scss";

export default {
  name: "loan",
  components: { headNav, footPage },
  data() {
    return {};
  },
};
</script>

<style scoped>
.content_title {
  font-size: 25px;
}
.titleNum {
  color: #1c9234;
  font-weight: 600;
}
.title {
  font-size: 30px !important;
  margin-top: 15px;
  font-weight: 600;
}
p {
  margin-bottom: 30px;
}
.bigContent {
  top: 133px;
  margin-top: 30px !important;
  box-shadow: 0px 0px 5px #ddd;
  padding-bottom: 0px;
  margin-bottom: 170px;
}
p span {
  color: #1c83ff;
  font-weight: 550;
}
</style>